import { baseURL } from '../../../functions/baseUrl'
import {useEffect, useRef, useState} from "react";
import { Speed, SpeedContainer } from './style'

export default function RecievedVoiceMessage(props) {
  const ref = useRef(null)

  const [speed, setSpeed] = useState(1)

  useEffect( () => {
    const loadVoice = async () => {
      const audioSource = ref.current;
      const cookies = document.cookie.split(";")
  
      const result = await fetch(`${baseURL}/download/${props.message.file.id}/`, {
        headers: {
          Authorization: cookies[cookies?.length - 1],
          'Content-Type': 'audio/mpeg'
        }
      });
  
      const blob = await result.blob();
  
      if (blob) {
        audioSource.src = URL.createObjectURL(blob);
      } else {
        console.warn("Can not load");
      }
    }
  
    loadVoice()
  }, [])

  const handleControlSpeed = () => {
    const audioSource = ref.current;
    let newSpeed

    if (speed === 2) {
      newSpeed = 1
    } else {
      newSpeed = speed + 0.5
    }
    setSpeed(newSpeed)
    audioSource.playbackRate = newSpeed
  }

  return (
    <SpeedContainer>
      <audio
        ref={ref}
        controls />
      <Speed onClick={handleControlSpeed}>
      {speed}x
      </Speed>
    </SpeedContainer>
  );
}
